import React from "react";
import pilLogo from "assets/images/pil-logo.png";

const PILBadge = () => {
  return (
    <div
      style={{
        background: "#ffffff",
        padding: "6px 10px",
        borderRadius: "8px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "fit-content",
        border: "1px solid #E6E7EA"
      }}
    >
      <img
        src={pilLogo}
        alt="PIL"
        style={{
          width: "26px",
          height: "26px",
          objectFit: "contain",
        }}
      />
    </div>
  );
};

export default PILBadge;
